import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// GLOBAL FUNCTIONS
import { apiFetch, doCallback, modalFunctions } from 'functions';

// STYLES
import style from './upload.module.scss';

// MAIN COMPONENT
const Upload = ({ value, children = value, placeholder }) => {
  const { values, setFieldValue } = useFormikContext() || {};

  const isTypeMatch = useMemo(() => values?.file?.type === "application/pdf", [values])

  const handleUploadFile = useCallback(() => {
    isTypeMatch ?
      apiFetch({
        method: 'POST',
        headers: {
          'Content-Type': 'application/pdf',
          'Content-Length': values.file.size.toString()
        },
        endpoint: ENDPOINTS.admin.adminForm.upload(value),
        queryParams: {
          fileName: values.file.name
        },
        useQueryString: true,
        body: values.file,
        onSuccess: () => {
          doCallback(setFieldValue, 'file', undefined);
          location.reload()
        },
        loadingMessage: 'Updating',
        successMessage: 'Updated.',
        errorMessage: 'Unable to update.'
      }) : modalFunctions.error('File must be a PDF');
  }, [isTypeMatch, values.file, value, setFieldValue]);

  // RENDER
  return children ? (
    <div className='d-flex align-items-center'>
     <Button className={style.uploadButton} onClick={handleUploadFile}>
        Upload File
     </Button>
    </div>
  ) : placeholder;
};

export default Upload;
